export const environment = {
  production: true,
  servicesBaseUrl: 'https://dashboard.highfieldcore.com',
  signalRBaseUrl: 'https://dashboard.highfieldcore.com/signalr',
  coreUrl: 'https://www.highfieldcore.com/',
  sentryEnvironment: 'Production',
  sentryReleaseVersion: 'Core@3.1.0',
  sentryTraceRate: 0.1
};
